<template>
  <div class="line-chart-card">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <el-tooltip v-if="tooltip" effect="dark" :content="tooltip" placement="top" style="margin-left: 4px">
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <i class="separator"></i>
        <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div ref="chart" class="echarts" :style="`height:${minHeight}px `"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  inject: ['ratioConfig'],
  props: {
    height: {
      type: Number,
      default: 344,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    // // 数据名称
    // dataName: {
    //   type: String,
    //   default: '',
    // },
    // 提示语
    isShowTooltip: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 横坐标配置
    xAxis: {
      type: Object,
      default: () => ({}),
    },
    // 纵坐标配置
    yAxis: {
      type: Object,
      default: () => ({}),
    },
    // 图例名称列表
    legendData: {
      type: Array,
      default: () => [],
    },
    // 系列数据列表
    seriesData: {
      type: Array,
      default: () => [],
    },
    // 数据单位
    unit: {
      type: String,
      default: '',
    },
    colorList: {
      type: Array,
      default: () => ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#FF6565', '#38ACF4', '#C28A50', '#C86C48', '#6A9A9A', '#4D8B0F', '#4DC83D', '#BA53C8', '#CE20B7', '#6742EB', '#3866F4', '#F1A909', '#E59691', '#1BDBDB', '#84C443', '#F46422', '#A37FE7', '#FC52B8', '#0D85CF', '#AB3709', '#068B8B'],
    },
  },
  computed: {
    minHeight() {
      if (this.height < 344) {
        return 344
      }
      return this.height
    },
    chartOption() {
      return {
        grid: [
          {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
        ],
        tooltip: {
          show: this.isShowTooltip,
          confine: true,
          trigger: 'axis',
          enterable: true,
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderColor: 'rgba(0,0,0,0.65)',
          formatter: (params) => {
            const len = params.length
            const date = params[0].name || ''
            const dataTitle = (params[0].value[2] || {}).dataTitle || ''
            let html = ''

            html += `<div class="tooltip-inner">
                      <div class="tootip-title">${date} ${dataTitle}</div>`

            for (let i = 0; i < len; i++) {
              const serie = params[i]
              const pointColor = serie.color
              const serieName = serie.seriesName
              const serieValue = serie.value[1]
              const ratioList = (serie.value[2] || {}).ratioList || []

              html += `<div class="tooltip-serie-row">
                         <i class="tooltip-serie-row-point" style="background: ${pointColor};"></i>
                         <div class="tooltip-serie-detail">
                          <div class="tooltip-serie-name">${serieName}:</div>
                          <div class="tooltip-serie-data">
                            <span class="tooltip-serie-data-value">${serieValue}${this.unit}</span>`

              if (this.ratioConfig.showRatio) {
                html += '<div class="tooltip-serie-data-change-situation-wrapper">'
                for (let j = 0; j < ratioList.length; j++) {
                  const ratio = ratioList[j]
                  html += `<p class="tooltip-serie-data-change-situation">
                            <span class="tooltip-serie-situation-label">${ratio.name}</span>
                            <i class="${`tooltip-serie-situation-icon ${!ratio.hideChangeTrend && ratio.value > 0 ? 'increase' : ''} ${!ratio.hideChangeTrend && ratio.value < 0 ? 'decrease' : ''}`}"></i>
                            <span class="${`tooltip-serie-situation-value ${!ratio.hideChangeTrend && ratio.value > 0 ? 'increase' : ''} ${!ratio.hideChangeTrend && ratio.value < 0 ? 'decrease' : ''}`}">${ratio.value === null || typeof ratio.value === 'undefined' ? '--' : `${(ratio.value * 100).toFixed(2).replace('-', '')}%`}</span>
                          </p>`
                }
                html += '</div>'
              }

              html += `</div>
                    </div>
                  </div>`
            }
            html += '</div>'
            return html
          },
        },
        legend: {
          icon: 'circle',
          type: 'scroll',
          left: 'center',
          padding: [5, 20],
          data: this.legendData,
        },
        xAxis: {
          type: 'category',
          ...this.xAxis,
        },
        yAxis: {
          type: 'value',
          // min: 'dataMin',
          // max: 'dataMax',
          ...this.yAxis,
        },
        series: this.seriesData.map((item) => ({ type: 'line', showSymbol: item?.data?.length === 1, ...item })),
        color: this.colorList,
      }
    },
  },
  watch: {
    height() {
      let h = 0
      if (this.height < 344) {
        h = 344
      } else {
        h = this.height
      }
      this.chart.resize({
        height: h,
      })
    },
    chartOption: {
      handler() {
        this.chart.setOption(this.chartOption, true)
        this.chart.resize()
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.init()
  },
  destroyed() {
    this.chart.dispose()
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption(this.chartOption, true)
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
  },
}
</script>

<style lang="scss">
.line-chart-card {
  // overflow: hidden;
  .echarts {
    width: 100%;
    height: 344px;
  }
  .tooltip-inner {
    padding: 16px;
    color: #fff;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
    .tootip-title {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .tooltip-serie-row {
      display: flex;
      align-items: flex-start;
      margin-top: 16px;
      .tooltip-serie-row-point {
        position: relative;
        top: 7px;
        flex: none;
        width: 8px;
        height: 8px;
        border-radius: 5px;
      }
      .tooltip-serie-detail {
        display: flex;
        flex-direction: column;
        margin-left: 4px;
        .tooltip-serie-name {
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
        }
        .tooltip-serie-data {
          display: flex;
          align-items: center;
          margin-top: 4px;
          .tooltip-serie-data-value {
            margin-right: 8px;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
          }
          .tooltip-serie-data-change-situation-wrapper {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            .tooltip-serie-data-change-situation {
              flex: none;
              margin-left: 16px;
              .tooltip-serie-situation-label {
                font-size: 12px;
                font-weight: normal;
                line-height: 22px;
                color: #FFF
              }
              .tooltip-serie-situation-icon {
                display: inline-block;
                &.increase {
                  position: relative;
                  top: -1px;
                  width: 10px;
                  height: 7px;
                  background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
                  background-size: 100%;
                }
                &.decrease {
                  position: relative;
                  top: -1px;
                  width: 10px;
                  height: 7px;
                  background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
                  background-size: 100%;
                }
              }
              .tooltip-serie-situation-value {
                &.increase {
                  font-size: 12px;
                  font-weight: normal;
                  line-height: 14px;
                  color: #0FC570;
                }
                &.decrease {
                  font-size: 12px;
                  font-weight: normal;
                  line-height: 14px;
                  color: #EA0000;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.line-chart-card {
  border-radius: 2px;
  // overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      ::v-deep .QS-icon-question-outline {
        color: #C0C4CC;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
    .card-header-right {

    }
  }
  .card-body {
    .card-body-inner {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 26px 0 0 0;
      border-left: 1px solid #ECEEF4;
      border-right: 1px solid #ECEEF4;
      border-bottom: 1px solid #ECEEF4;
    }
  }
}
</style>
